/**
 * タイマーに関する汎用処理。
 */
export class Timers {
  /**
   * 指定のミリ秒数以後に処理を再開します。
   *
   * @param millis 中断する時間(ミリ秒数)。
   * @returns Promiseの履行結果はありません。
   */
  static async delay(millis: number) {
    return new Promise((resolve) => {
      setTimeout(resolve, millis);
    });
  }
}
export default Timers;
